<template>
  <i-modal
    ref="i-modal"
    :closeable="closeable"
    :bgcolor="mask ? 'rgba(0,0,0,0.7)' : ''"
    @opened="$emit('opened')"
    @closed="$emit('closed')"
  >
    <div
      class="modal el-reset"
      :class="[type, {'border-none': !border, 'max-height': maxHeight}]"
    >
      <span
        v-if="closeBtn"
        class="close"
        :class="type"
        :style="{ fontSize: closeBtnSize }"
        @click="toggleShow(false)"
      >
        &times;
      </span>
      <span
        v-if="prevBtn"
        class="prev"
        :class="type"
        @click="$emit('prev')"
      >
        &larr;
        <span class="prev-text">{{ $t('back') }}</span>
      </span>
      <span
        v-if="customBtn"
        class="customButton"
      >
        <slot name="customBtn" />
      </span>
      <div class="overflow">
        <slot />
      </div>
    </div>
  </i-modal>
</template>
<script>
import IModal from '@/components/IModal'
export default {
  name: 'VrLoungeModal',
  components: {
    IModal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: true
    },
    type: {
      type: String, // 'dark' | 'white' | 'transparent'
      default: 'dark'
    },
    closeBtn: {
      type: Boolean,
      default: false
    },
    closeBtnSize: {
      type: String,
      default: '24px'
    },
    prevBtn: {
      type: Boolean,
      default: false
    },
    previewBtn: {
      type: Boolean,
      default: false
    },
    customBtn: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    show: 'toggleShow'
  },
  mounted () {
    this.toggleShow()
  },
  methods: {
    toggleShow (bool = this.show) {
      if (bool) this.$refs['i-modal'].show()
      else this.$refs['i-modal'].hide()
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~css/addon/main'
.modal {
  position: relative
  max-height: 85vh
  padding: 40px 20px 20px 20px
  max-width: 100vw
  min-width: 400px
  display: flex
  flex-direction: column
  transition: transform 0.5s ease-out
  .overflow {
    height: 100%
    @media (max-width: $response) {
      height: calc(var(--vh,1vh)*100) !important
    }
  }
  &.dark {
    background-color: rgba(0,0,0,0.8)
  }
  &.white {
    background-color: #fff
  }
  &.new {
    padding: 0 0 20px 0
    border-radius: 15px
    background: rgba(255, 255, 255, 0.6)
    backdrop-filter: blur(30px)
    -webkit-backdrop-filter: blur(30px)
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.4)
    @media (max-width: $response) and (min-width: $response-xs) {
      max-height: 90vh
    }
  }
  &.new-white {
    background-color #fff
    padding: 10px 0 30px
    border-radius: 15px
  }
  &.transparent {
    background-color: transparent
  }
  &.border-none {
    border: none
    padding: 0
  }
  &.max-height {
    height: 100%
  }

  @media (max-width: $response-xs) {
    max-height: 100vh
    max-height: calc(var(--vh, 1vh) * 100)
    min-width: 100%
  }
}
.close, .prev, .customButton {
  position: absolute
  z-index: 1
  top: 16px
  font-size: 24px
  line-height: 10px
  cursor: pointer
  &.white {
    color: #000
  }
  &.dark {
    color: #fff
  }
  &.new {
    color: $vrl-primary-text
    top: 32px
    right: 40px
    font-size: 40px
    line-height: 40px
  }
  &.new-white  {
    color: $vrl-primary-text
    top: 24px
    right: 32px
    font-size: 32px
    @media (max-width: $response-xs) {
      top: 24px
      right: 16px
    }
  }
}

.customButton, .prev {
  display: flex
  align-items: center
  left: 15px
}

.close {
  right: 24px
}

.prev-text {
  margin-left: 4px
  font-size: 14px
}

.preview-btn {
  position: absolute
  z-index: 1
  top: 12px
  right: 12px
  padding: 4px 8px
  border-radius: 4px
  border: 1px solid $light-pink-color
  color: $light-pink-color
  background-color: transparent
}
</style>
